import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.EduLogout = class EduLogout extends Snappy.BaseComponent {
    static get tagName() {
        return 'bootroom-logout';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.button = $(this.$element);
        this.url = this.button.data('logoutUrl');
        this.openWindow = this.button.data('openWindow');
    }

    handleClick(e) {
        if (this.openWindow) {
            this.openWindow();
        } else {
            this.openIframe();
            e.stopPropagation();
        }
    }
    
    setEventListeners() {
        this.button.on('click', this.handleClick.bind(this));
    }

    render() {
        this.setVars();
        this.setEventListeners();
    }

    openIframe() {
        $('body').append(`<iframe id='logout-hiddenProcess' src='${this.url}' style='display:none'></iframe>`);
        $('body').append(`<div id='logout-message' style='z-index: 10; position:absolute; height: 100vh; width: 100vw'>
                <div style='position:absolute; top:50%; left:50%; transform: translate(-50%,-50%); padding: 40px; background-color:#011e41; color:white; width: 100%; max-width: 500px; text-align: center'>
                    Logging Out
                </div></div>`);
        //$('#logout-hiddenProcess').load(this.url, () => { alert("page loaded") })
        $('#logout-hiddenProcess').on('load', function () {
            window.location.reload();
        });
    }

    openWindow() {
        var logoutWindow = window.open(this.url, 'logoutWindow', 'width=1, height=1,toolbar=no,status=no');

        logoutWindow.addEventListener('load', () => {
            logoutWindow.close();
            window.location.reload();
        }, false);

        //logoutWindow.addEventListener('DOMContentLoaded', () => {
            //console.log("a");
        //}, false);
    }
}



// WEBPACK FOOTER //
// ./components/edu-logout/scripts/_edu-logout.js